import * as ProfitOptimizationStoryTask from "../temat3_kwadratowa/podtemat4_optymalizacja_types/ProfitOptimizationStoryTask";
import * as CubicLocalExtremumTask from "./podtemat3_ekstrema_types/CubicLocalExtremumTask";
import * as QuarticGlobalExtremumTask from "./podtemat3_ekstrema_types/QuarticGlobalExtremumTask";
import * as CuboidEdgeSumOptimizationTask from "./podtemat4_optymalizacja_types/CuboidEdgeSumOptimizationTask";

export const registry = {
  ProfitOptimizationStoryTask,
  CubicLocalExtremumTask,
  QuarticGlobalExtremumTask,
  CuboidEdgeSumOptimizationTask,
};

export function generateTasks() {
  return [
    ProfitOptimizationStoryTask.generateTask(),
    CubicLocalExtremumTask.generateTask(),
    QuarticGlobalExtremumTask.generateTask(),
    CuboidEdgeSumOptimizationTask.generateTask(),
  ];
}

export function renderTask(task) {
  const m = registry[task.type];
  return m ? m.renderTask(task) : null;
}

export function renderInput(task, userAnswer, onChange, disabled) {
  const m = registry[task.type];
  return m ? m.renderInput(task, userAnswer, onChange, disabled) : null;
}

export function checkAnswer(task, userAnswer) {
  const m = registry[task.type];
  return m ? m.checkAnswer(task, userAnswer) : false;
}

export function renderAnswer(task) {
  const m = registry[task.type];
  return m ? m.renderAnswer(task) : null;
}

export function renderExplanation(task) {
  const m = registry[task.type];
  return m ? m.renderExplanation(task) : null;
}

export function renderUserAnswer(task, userAnswer) {
  const m = registry[task.type];
  return m && m.renderUserAnswer ? m.renderUserAnswer(task, userAnswer) : null;
}

export default {
  registry,
  generateTasks,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};
